// 🔹 React Core
import React, { FC } from 'react';

// 🔹 Animation Library
import { motion } from 'framer-motion';

// 🔹 Types
import type { Exercise } from './mockData';

interface ExerciseCardProps {
  exercise: Exercise;
  index: number;
  letterKey: string;
  isDragging: boolean;
  isOverlay?: boolean;
}

export const ExerciseCard: FC<ExerciseCardProps> = ({ exercise, isDragging, isOverlay }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{
        opacity: isDragging ? 0.4 : 1,
        y: 0,
        scale: isDragging && isOverlay ? 1.05 : 1,
        borderColor:
          isDragging && isOverlay ? 'rgba(255, 161, 0, 0.5)' : 'rgba(255, 255, 255, 0.05)',
        boxShadow: isDragging && isOverlay ? '0 10px 30px rgba(0,0,0,0.5)' : 'none',
      }}
      whileHover={{
        scale: 1.01,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderColor: 'rgba(255, 255, 255, 0.2)',
      }}
      whileTap={{ scale: 0.98 }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25,
        layout: { duration: 0.2 },
      }}
      className={`exercise-card ${isDragging ? 'dragging' : ''}`}
    >
      <div className="exercise-drag-handle">
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none">
          <circle cx="2" cy="2" r="1.5" fill="currentColor" opacity="0.3" />
          <circle cx="2" cy="9" r="1.5" fill="currentColor" opacity="0.3" />
          <circle cx="2" cy="16" r="1.5" fill="currentColor" opacity="0.3" />
          <circle cx="10" cy="2" r="1.5" fill="currentColor" opacity="0.3" />
          <circle cx="10" cy="9" r="1.5" fill="currentColor" opacity="0.3" />
          <circle cx="10" cy="16" r="1.5" fill="currentColor" opacity="0.3" />
        </svg>
      </div>
      <div className="exercise-thumbnail-box">
        <img
          src={exercise.thumbnail || 'https://via.placeholder.com/60'}
          alt={exercise.name}
          className="exercise-thumbnail-img"
        />
      </div>
      <div className="exercise-card-content">
        <h4 className="exercise-card-name">{exercise.name}</h4>
        <div className="exercise-card-tags">
          <span className="tag-muscle">{exercise.muscleGroup}</span>
          {exercise.type.slice(0, 1).map((t) => (
            <span key={t} className={`tag-type tag-${t.toLowerCase()}`}>
              {t}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
